import * as tasks from './tasks';
import * as stats from './stats';
import * as projectAudit from './projectAudit';
import * as customerAudit from './customerAudit';
import * as billing from './billing';
import * as team from './team';
import * as lidar from './lidar';
import * as batches from './batches';
import * as overview from './overview';
import * as selfserve from './selfserve';
import * as labeling from './labeling'; // TODO: move this into studio
import * as studio from './studio';
import * as document from './document';
import * as documentAIGo from './documentAiGo';
import * as documentProjectMetrics from './documentProjectMetrics';
import * as contentUnderstanding from './contentUnderstanding';
import * as genai from './genai';
import * as customer from './customer';
import * as corp from './corp';
import * as demos from './demos';
import * as legal from './legal';
import * as workerProperties from './workerProperties';
import * as sensorFusion from './sensorFusion';
import * as squads from './squads';
import * as embeddedContent from './embeddedContent';

/* --- RESERVED AREA START --- */
/* --- GENERATED PRODUCT IMPORTS --- */

/* --- RESERVED AREA END --- */

export default {
  tasks,
  stats,
  customerAudit,
  projectAudit,
  billing,
  team,
  lidar,
  batches,
  overview,
  selfserve,
  labeling,
  studio,
  document,
  documentAIGo,
  documentProjectMetrics,
  contentUnderstanding,
  genai,
  customer,
  corp,
  demos,
  legal,
  workerProperties,
  sensorFusion,
  squads,
  embeddedContent,
  /* --- RESERVED AREA START --- */
  /* --- GENERATED PRODUCT EXPORTS --- */

  /* --- RESERVED AREA END --- */
};
